import React, { useEffect } from 'react';
import {useSelector} from 'react-redux';
import { Form, Row, Col, message } from 'antd';
import {
  LayoutWithoutAuth,
  Select,
  Button,
  Typography,
} from 'components';
import { useHistory, useParams } from 'react-router-dom';
import './login.less';
import * as loginService from '../../services/login.service';
import { customMessages } from 'utils';

const { Title} = Typography;

const SelectOtpPage = () => {
  let history = useHistory();
  let { gsmNumber } = useParams();
  const [msisdnList, setMsisdnList] = React.useState([]);
 
  const auth = useSelector(state=>state.auth);

  function fetchOtpNumbers(token) {
    loginService
      .getOtpMsisdns(token)
      .then((result) => {
        const { msisdnOtpList } = result;
        setMsisdnList(msisdnOtpList);
      })
      .catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  useEffect(() => {
    fetchOtpNumbers(auth.preToken);
  }, []);

  return (
    <LayoutWithoutAuth className="signup">
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center" className="signup-box">
            <Col span={24} className="flex-center-center">
              <h1 className="section__title">Telefon Numarası Seçimi</h1>
            </Col>
            <Col
              span={24}
              className="flex-center-center margin-bottom-spacing-s"
            >
              <p className="info-text">
              Doğrulama kodunun gönderileceği telefon numarasını seçiniz.
              </p>
            </Col>
            <Form
              style={{ width: '100%' }}
              name="forgotPassword"
              onFinish={(values) => {
                history.push(`/Login/${gsmNumber}/${values.otpNumber}/otp-confirmation`);
              }}
              onFinishFailed={(event) =>
                console.log(
                  'onFinishFailed applySmsCode-signup form ==> ',
                  event
                )
              }
            >
              <Form.Item name="otpNumber">
                <Select
                  style={{ width: '100%' }}
                  data={msisdnList}
                  keyvalue={'msisdn'}
                  labelvalue={'msisdn'}
                  placeholder={'Telefon Numarası Seçiniz.'}
                />
              </Form.Item>
              <Form.Item>
                <Form.Item>
                  <Row justify="center" gutter={28}>
                    <Col  xs={9}  sm={12}>
                      <Button
                        type="ghost"
                        onClick={() => history.push( `/Login/${gsmNumber}`)}
                      >
                        Önceki Adım
                      </Button>
                    </Col>
                    <Col  xs={15}  sm={12}>
                      <Button type="primary" htmlType="submit" shape="round">
                      Doğrulama Kodu Gönder
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form.Item>
            </Form>
          </Row>
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center">
            <Title level={3}>Üyeliğiniz Yok mu?</Title>
          </Row>
          <Row justify="center" className="margin-bottom-spacing-xxl-4">
            <Button
              type="ghost"
              style={{ width: 180 }}
              onClick={() => history.push('/SignUp')}
            >
              Üye Ol
            </Button>
          </Row>
        </Col>
      </Row>
    </LayoutWithoutAuth>
  );
};
export default SelectOtpPage;
